<template lang="pug">
div
  v-card(flat)
    v-card-title General Event Information
    keep-alive
      validation-observer(
        ref="o01",
        v-slot="{ invalid }",
        :persist="true",
        vid="o01"
      )
        v-container
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Event Name
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_Title",
                  counter,
                  maxlength="100",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Event Location
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_Location",
                  counter,
                  maxlength="100",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Civic Association
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-select.pb-3.pl-3(
                :items="civicAssociations",
                item-value="id",
                solo,
                attach,
                v-model="SEA_CivicAssociation",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Summary
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-textarea.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_Summary",
                  counter,
                  maxlength="1000",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Vision
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-textarea.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_Vision",
                  counter,
                  maxlength="1000",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Is this a repeat of an event previously held in Arlington County?
              v-radio-group(v-model="SEA_PreviouslyHeld" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row(v-if="SEA_PreviouslyHeld === 'Yes'")
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Previous Date
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_PreviousDate",
                counter,
                maxlength="100",
                :disabled="disabled"
              )
          v-row(v-if="SEA_PreviouslyHeld === 'Yes'")
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Previous Location
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_PreviousLocation",
                counter,
                maxlength="100",
                :disabled="disabled"
              )
          v-row(v-if="SEA_PreviouslyHeld === 'Yes'")
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Previous Sponsor
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_PreviousSponsor",
                counter,
                maxlength="100",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Single or Repeating
            v-col(:lg="9", :md="9", :sm="12", :cols="12") 
              v-radio-group(v-model="SEA_IsThisaSingle" row dense :disabled="disabled")
                v-radio(
                  v-for="option in singleOrSeries",
                  :key="option"
                  :label="option"
                  :value="option"
                )
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.d-none(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_IsThisaSingle",
                  counter,
                  maxlength="100",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_IsThisaSingle == 'Single'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Date and Times
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              v-container
                v-row
                  v-col(:lg="3", :md="3", :sm="12", :cols="12")
                    validation-provider(
                      rules="required",
                      v-slot="{ errors }",
                      immediate
                    )
                      v-datetime-picker(
                        label="Setup Event",
                        v-model="SEA_SetupTime",
                        dateFormat="MM/dd/yyyy",
                        timeFormat="h:mm a",
                        :date-picker-props="dateProps",
                        :time-picker-props="timeProps",
                        :disabled="disabled"
                      )
                      p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                  v-col(:lg="3", :md="3", :sm="12", :cols="12")
                    validation-provider(
                      rules="required",
                      v-slot="{ errors }",
                      immediate
                    )
                      v-datetime-picker(
                        label="Start",
                        v-model="SEA_EventStartTime",
                        dateFormat="MM/dd/yyyy",
                        timeFormat="h:mm a",
                        :date-picker-props="dateProps",
                        :time-picker-props="timeProps",
                        :disabled="disabled"
                      )
                      p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                  v-col(:lg="3", :md="3", :sm="12", :cols="12")
                    validation-provider(
                      rules="required",
                      v-slot="{ errors }",
                      immediate
                    )
                      v-datetime-picker(
                        label="End",
                        v-model="SEA_EventEndTime",
                        dateFormat="MM/dd/yyyy",
                        timeFormat="h:mm a",
                        :date-picker-props="dateProps",
                        :time-picker-props="timeProps",
                        :disabled="disabled"
                      )
                      p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                  v-col(:lg="3", :md="3", :sm="12", :cols="12")
                    validation-provider(
                      rules="required",
                      v-slot="{ errors }",
                      immediate
                    )
                      v-datetime-picker(
                        label="Breakdown",
                        v-model="SEA_BreakdownTime",
                        dateFormat="MM/dd/yyyy",
                        timeFormat="h:mm a",
                        :date-picker-props="dateProps",
                        :time-picker-props="timeProps",
                        :disabled="disabled"
                      )
                      p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                v-row(v-if="SEA_EventStartTime < SEA_SetupTime")
                  v-col(:lg="12", :md="12", :sm="12", :cols="12")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your event setup must be before your start time.
                v-row(v-if="SEA_EventEndTime <= SEA_EventStartTime")
                  v-col(:lg="12", :md="12", :sm="12", :cols="12")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your event start must be before your end time.
                v-row(v-if="SEA_BreakdownTime < SEA_EventEndTime")
                  v-col(:lg="12", :md="12", :sm="12", :cols="12")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your event end must be before your breakdown time.
          v-row(v-if="SEA_IsThisaSingle == 'Series'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Date and Times
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              v-container
                v-row(v-for="event in events", :key="event.id")
                  v-col(:lg="11", :md="11", :sm="11")
                    v-row
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(
                          rules="required",
                          v-slot="{ errors }"
                          immediate
                        )
                          v-datetime-picker(
                            label="Setup Series",
                            v-model="event.SEA_SetupTime",
                            dateFormat="MM/dd/yyyy",
                            timeFormat="h:mm a",
                            :date-picker-props="dateProps",
                            :time-picker-props="timeProps",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(
                          rules="required",
                          v-slot="{ errors }"
                          immediate
                        )
                          v-datetime-picker(
                            label="Start",
                            v-model="event.SEA_EventStartTime",
                            dateFormat="MM/dd/yyyy",
                            timeFormat="h:mm a",
                            :date-picker-props="dateProps",
                            :time-picker-props="timeProps",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(
                          rules="required",
                          v-slot="{ errors }"
                          immediate
                        )
                          v-datetime-picker(
                            label="End",
                            v-model="event.SEA_EventEndTime",
                            dateFormat="MM/dd/yyyy",
                            timeFormat="h:mm a",
                            :date-picker-props="dateProps",
                            :time-picker-props="timeProps",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                      v-col(:lg="3", :md="3", :sm="12", :cols="12")
                        validation-provider(
                          rules="required",
                          v-slot="{ errors }"
                          immediate
                        )
                          v-datetime-picker(
                            label="Breakdown",
                            v-model="event.SEA_BreakdownTime",
                            dateFormat="MM/dd/yyyy",
                            timeFormat="h:mm a",
                            :date-picker-props="dateProps",
                            :time-picker-props="timeProps",
                            :disabled="disabled"
                          )
                          p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
                  v-col(:lg="1", :md="1", :sm="1")
                    v-btn.mx-2(fab, small, @click="removeEvent(event.id)") 
                      v-icon mdi-minus
                  v-col(:lg="12", :md="12", :sm="12", :cols="12" v-if="event.SEA_EventStartTime < event.SEA_SetupTime")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your event setup must be before your start time.
                  v-col(:lg="12", :md="12", :sm="12", :cols="12" v-if="event.SEA_EventEndTime <= event.SEA_EventStartTime")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your event start must be before your end time.
                  v-col(:lg="12", :md="12", :sm="12", :cols="12" v-if="event.SEA_BreakdownTime < event.SEA_EventEndTime")
                    p.pb-0.red--text.text--lighten-1.pl-4 Your event end must be before your breakdown time.
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              v-btn.mx-2(fab, small, color="primary", @click="addEvent()")
                v-icon mdi-plus
              span Add Date

        v-container
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Estimated Minimum Number of Attendees & Participants
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_AttendeesMin",
                  counter,
                  maxlength="100",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}

        v-container
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Estimated Maximum Number of Attendees & Participants
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required|integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_AttendeesMax",
                  counter,
                  maxlength="100",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
</template>

<script>
import { mapState } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import store from "../store";
import moment from "moment";

let thirtyDaysAhead = moment().add(30, "days");
thirtyDaysAhead = moment(thirtyDaysAhead).format("YYYY-MM-DDThh:mm:ss");

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      civicAssociations: (state) => state.civicAssociations,
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
      singleOrSeries: (state) => state.singleOrSeries,
    }),
    ...mapFields([
      "data.SEA_AmusementDeviceDesc",
      "data.SEA_Title",
      "data.SEA_Location",
      "data.SEA_CivicAssociation",
      "data.SEA_Summary",
      "data.SEA_Vision",
      "data.SEA_PreviouslyHeld",
      "data.SEA_PreviousDate",
      "data.SEA_PreviousSponsor",
      "data.SEA_PreviousLocation",
      "data.SEA_IsThisaSingle",
      "data.SEA_SetupTime",
      "data.SEA_EventStartTime",
      "data.SEA_EventEndTime",
      "data.SEA_BreakdownTime",
      "data.SEA_AttendeesMin",
      "data.SEA_AttendeesMax",
      "data.disabled",
    ]),
    ...mapMultiRowFields(["data.events"]),
  },
  data() {
    return {
      // functions to limit dates:
      //https://darrenfang.github.io/vuetify-datetime-picker/
      //https://github.com/darrenfang/vuetify-datetime-picker/blob/master/src/app.vue
      dateProps: {
        min: thirtyDaysAhead,
        showCurrent: thirtyDaysAhead,
      },
      timeProps: {
        ampmInTitle: false,
      },
    };
  },
  methods: {
    addEvent() {
      let nextIndex = this.data.events.length;
      if (nextIndex < 15) {
        this.data.events.push({
          id: nextIndex,
          SEA_SetupTime: undefined,
          SEA_EventStartTime: undefined,
          SEA_EventEndTime: undefined,
          SEA_BreakdownTime: undefined,
        });
      } else {
        // show message
      }
    },
    removeEvent(event) {
      this.data.events.splice(event, 1);
    },
  },
};
</script>

<style>
/* .main-container button {
  background-color: transparent !important;
} */
/* td > button.v-btn {
  background-color: transparent !important;
} */
/* div.v-picker__body.theme--light button  */
.v-picker button {
  background-color: transparent !important;
}
/**div.v-date-picker-header.theme--light > div > div > button */
</style>